export interface EcommercePlatform {
  cart_uri: string;
  dealer_id?: string;
  macrodata_uri: string;
  platform: string;
  url_production: string[];
  url_test: string[];
}

export interface EcommerceDataForm {
  cart_uri: string;
  macrodata_uri: string;
  url_production: string;
  url_test: string;
}

export interface EcommerceWidget {
  sections: WidgetSection[];
}

export interface WidgetSection {
  section_id: string;
  section: string;
  dom: string | null;
  dom_var_price: string | null;
  dom_qty?: string | null;
  dom_page_identification: string | null;
  dom_list_item?: string | null;
  dom_payment_type?: string | null;
  enabled: boolean;
  widgets: Widget[];
}

export interface Widget {
  widget_id: string;
  type: string;
  content: string;
  content_popup?: string;
  position: string;
  dom_widget: string | null;
  dom_payment_check?: string | null;
  dom_payment?: string | null;
  dom_payment_class?: string | null;
  enabled: boolean | any;
  background_color?: string;
  buttons_color?: string;
  background_buttons_color: string;
}

export enum PluginPlatforms {
  MAG_1 = 'MAG1',
  MAG_2 = 'MAG2',
  PSH_16 = 'PSH16',
  PSH_17 = 'PSH17',
  WOO_30 = 'WOO30',
  API = 'API',
  PEPPER = 'PEPPER',
}

export interface PluginPlatform {
  platformName: string,
  platformValue: PluginPlatforms
}

export const pluginPlatform: PluginPlatform[] = [
  {
    platformName: 'Magento 1',
    platformValue: PluginPlatforms.MAG_1,
  },
  {
    platformName: 'Magento 2',
    platformValue: PluginPlatforms.MAG_2,
  },
  {
    platformName: 'Prestashop 1.6',
    platformValue: PluginPlatforms.PSH_16,
  },
  {
    platformName: 'Prestashop 1.7',
    platformValue: PluginPlatforms.PSH_17,
  },
  {
    platformName: 'Woocomerce',
    platformValue: PluginPlatforms.WOO_30,
  },
  {
    platformName: 'API',
    platformValue: PluginPlatforms.API,
  },
  {
    platformName: 'PEPPER',
    platformValue: PluginPlatforms.PEPPER,
  },
];

export interface PluginPayment {
  name: string;
  value: PluginPayments;
}

export enum PluginPayments {
  Radio = 'Radio',
  Check = 'Check',
  Class = 'Class',
}

export const pluginPaymentOptions: PluginPayment[] = [
  {
    name: 'Radio',
    value: PluginPayments.Radio,
  },
  {
    name: 'Check',
    value: PluginPayments.Check,
  },
  {
    name: 'Class',
    value: PluginPayments.Class,
  },
];

export interface WidgetPosition {
  name: string;
  value: WidgetPositions;
}

export enum WidgetPositions {
  In = 'in',
  After = 'after',
  Before = 'before',
}

export const widgetPositionOptions: WidgetPosition[] = [
  {
    name: 'After',
    value: WidgetPositions.After,
  },
  {
    name: 'In',
    value: WidgetPositions.In,
  },
  {
    name: 'Before',
    value: WidgetPositions.Before,
  },
];
export interface SelectColor {
  value: string;
}


